import React from "react";
import { defineMessages } from "react-intl";
import MessageDialog from "./MessageDialog";
import Button from "../../button/Button";

const messages = defineMessages({
  ok: {
    id: "ok",
    defaultMessage: "Ok"
  }
});

/**
 * Alert dialog that shows an "Ok" button to dismiss the message shown to the user.
 * 
 * Props:
 * - onConfirm: Function called when the user presses the Ok button.
 * See MessageDialog, for additional props.
 */
const Alert = ({ onConfirm, ...restProps }) => (
  <MessageDialog {...restProps} autoSnap={false}>
    <Button title={messages.ok} onPress={onConfirm} />
  </MessageDialog>
);

Alert.defaultProps = {
  onConfirm: () => {}
};

export default Alert;
